export default "__VITE_ASSET__2uq_FP6X__"